/** Caps from the PixelSign spec. Tunable, but v1 has them. */
export const ENVELOPE_LIMITS = {
  maxDocumentBytes: 20 * 1024 * 1024,
  maxDocuments: 20,
  maxSigners: 20,
  maxFields: 200,
  maxMetadataKeys: 16,
  maxMetadataChars: 256,
  /** Largest `limit` on envelope list and search. */
  maxListLimit: 100,
  /** Page size when a list omits `limit`. */
  defaultListLimit: 25,
  /** Offset when a list omits `offset`. */
  defaultListOffset: 0,
  maxRemindsPerDay: 3,
  /** The largest `remind.max`: reminders per signer over an envelope's life, from every source. */
  maxRemindsPerSigner: 10,
  /** `remind.max` when a create leaves it out. */
  defaultRemindMax: 5,
  maxHtmlBytes: 1_000_000,
  maxHtmlImages: 20,
  maxHtmlImageBytes: 2_000_000,
  maxQuestionThreadsPerAsker: 50,
  maxQuestionMessagesPerThread: 100,
  maxQuestionChars: 2000,
  maxQuestionQuoteChars: 80,
  maxQuestionEmailsPerHour: 10,
  /** Retention is capped at five years and defaults to 90 days. */
  maxRetentionDays: 5 * 365,
  defaultRetentionDays: 90,
} as const

/** Sends and reminders allowed per organization and mode per hour, across its API keys and dashboard. */
export const SENDS_PER_HOUR = 30

/**
 * The largest create `payload` form field the API accepts: every document at
 * the HTML cap, doubled because JSON escaping can double characters like `"`
 * and `\`, plus room for the rest of the payload. Multer's 1 MB default
 * refused valid envelopes with more than about 1 MB of HTML in total.
 */
export const MAX_CREATE_PAYLOAD_BYTES = ENVELOPE_LIMITS.maxDocuments * ENVELOPE_LIMITS.maxHtmlBytes * 2 + 1_000_000

/** The consent signing pages show now; its text is `consentText` (helpers/consent). */
export const CONSENT_VERSION = 'consent.v2'

/**
 * The versions a signer can accept. A page loaded before a new version
 * deployed still shows, and sends, the one before it; recording that version
 * is accurate, since it's what they read.
 */
export const CONSENT_VERSIONS = ['consent.v1', CONSENT_VERSION] as const

/** The longest note a signer can send with a paper-copy request. */
export const PAPER_COPY_NOTE_MAX = 1000

/** A signer can ask for a paper copy once a day; a repeat within that is a no-op, so a double click or a retry emails once. */
export const PAPER_COPY_REQUEST_INTERVAL_MS = 24 * 60 * 60 * 1000

/** The largest paper-copy fee an organization can set: $1,000. */
export const PAPER_COPY_FEE_MAX_MICROS = 1_000_000_000
